import React from 'react';

// Plain CSS bar chart - no charting library needed for a handful of
// categorical bars. `bars` is [{ label, value, tone }], tone is one of
// 'blue' | 'green' | 'amber' | 'red' (defaults to blue).
const TONE_CLASSES = {
  blue: 'bg-komal-blue',
  green: 'bg-green-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
};

const money = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

const PaymentsBarChart = ({ title, bars }) => {
  const max = Math.max(1, ...bars.map((b) => b.value));

  return (
    <div>
      <div className="text-xs text-gray-500 mb-3">{title}</div>
      {bars.length === 0 ? (
        <p className="text-xs text-gray-400">No data in this range.</p>
      ) : (
        <div className="space-y-2.5">
          {bars.map((b) => (
            <div key={b.label}>
              <div className="flex justify-between text-xs mb-1">
                <span className="text-gray-700">{b.label}</span>
                <span className="font-medium">{money(b.value)}</span>
              </div>
              <div className="bg-gray-100 rounded h-2.5">
                <div
                  className={`h-2.5 rounded ${TONE_CLASSES[b.tone] || TONE_CLASSES.blue}`}
                  style={{ width: `${Math.max((b.value / max) * 100, 2)}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PaymentsBarChart;
